module.exports = "<p>\n  inspections-order-parties works!\n</p>\n"